
export var RenderFlags = {
    RENDER_NORMAL      : 0,
    RENDER_HIGHLIGHTED : 1,
    RENDER_HIDDEN      : 2,
    RENDER_SHADOWMAP   : 3,
    RENDER_FINISHED    : 4,
};

